// ** Third Party Components
import styled from "styled-components";

// ** Custom Components
import { StyledTableRow } from "./TableRow.styled";

// #####################################################

export const StyledTableHead = styled("thead")`
	${StyledTableRow} {
		font-weight: bold;
		background-color: ${({ theme: { isDarkMode } }) =>
			isDarkMode ? "#303030" : "#eaeaea"};
	}
`;

// #####################################################
